export default {
	resetSelected ({commit}) {
		commit('SET_MULTI_EDIT_DATA', {
			field: 'selected_ids',
			value: {}
		})
	},
	resetAll ({commit}) {
		commit('SET_MULTI_EDIT_DATA', {
			field: 'is_multi_edit_enabled',
			value: false
		})
		commit('SET_MULTI_EDIT_DATA', {
			field: 'selected_ids',
			value: {}
		})
	},
	onDeselectRow ({commit}, id) {
		commit('DESELECT_ID', id)
	},
	onSelectRow ({state, commit}, {id, code, name}) {
		if (state.selected_ids[`#${id}`]) {
			commit('DESELECT_ID', `#${id}`)
		} else {
		  commit('SELECT_ID', {
		  	id,
				code,
				name
		  })
		}
	},
	selectAllRows ({commit}, data) {
		data.forEach(vehicle => {
			commit('SELECT_ID', {
				id: vehicle.id,
				type: vehicle.type,
				license_plate: vehicle.license_plate
			})
		})
	},
	onSelectRows ({state, commit, getters}, vehicles = []) {
		const isAlreadySelected = getters.allPageIsSelected(vehicles)

		if (isAlreadySelected) {
			vehicles.forEach(vehicle => {
				commit('DESELECT_ID', `#${vehicle.id}`)
			})
		} else {
			vehicles.forEach(vehicle => {
				const element = state.selected_ids[`#${vehicle.id}`]

				if (!element) {
					commit('SELECT_ID', {
						id: vehicle.id,
						type: vehicle.type,
						license_plate: vehicle.license_plate
					})
				}
			})
		}
	}
}
